import React from 'react';
import { WbSunnyIcon, Folder, Business, Money } from '@material-ui/icons';
import ClickHoverInfoCard from '@jumbo/components/Common/ClickHoverInfoCard';

// import { MoneyIcon } from '@mui/icons-material/Money';
// import WbSunnyIcon from '@material-ui/icons/WbSunny';

const ClickIdeasWidget = ({ number, subTitle, icon, backgroundColor, clicklinkOnArrow }) => {
  return (
    <ClickHoverInfoCard
      icon={icon}
      backgroundColor={backgroundColor}
      title={number}
      subTitle={subTitle}
      clickLinkOnArrow={clicklinkOnArrow}
    />
  );
};

export default ClickIdeasWidget;
